// Generated by ReScript, PLEASE EDIT WITH CARE


function getCommonDetails(order) {
  return {
          order_crn: order.order_crn,
          status: order.status,
          geo_region_id: order.geo_region_id,
          vehicle_id: order.vehicle.vehicle_id,
          customer: {
            name: order.customer_info.name,
            id: order.customer_info.customer_id
          },
          partner: undefined,
          order_invoice_url: order.order_invoice_url
        };
}

function getVm(order_details) {
  var order;
  var accepted_order;
  var exit = 0;
  switch (order_details.TAG | 0) {
    case /* Open */0 :
        return getCommonDetails(order_details._0);
    case /* Accepted */1 :
    case /* Live */2 :
    case /* Ended */3 :
        exit = 2;
        break;
    case /* Cancelled */4 :
        var order$1 = order_details._0;
        var partner = order_details._1.partner_info;
        if (partner === undefined) {
          return getCommonDetails(order$1);
        }
        var init = getCommonDetails(order$1);
        return {
                order_crn: init.order_crn,
                status: init.status,
                geo_region_id: init.geo_region_id,
                vehicle_id: init.vehicle_id,
                customer: init.customer,
                partner: {
                  name: partner.name,
                  id: partner.msisdn,
                  vehicle: partner.vehicle_type
                },
                order_invoice_url: init.order_invoice_url
              };
    default:
      order = order_details._0;
      accepted_order = order_details._2;
  }
  if (exit === 2) {
    order = order_details._0;
    accepted_order = order_details._1;
  }
  var init$1 = getCommonDetails(order);
  return {
          order_crn: init$1.order_crn,
          status: init$1.status,
          geo_region_id: init$1.geo_region_id,
          vehicle_id: init$1.vehicle_id,
          customer: init$1.customer,
          partner: {
            name: accepted_order.partner_info.name,
            id: accepted_order.partner_info.msisdn,
            vehicle: accepted_order.partner_info.vehicle_type
          },
          order_invoice_url: init$1.order_invoice_url
        };
}

export {
  getCommonDetails ,
  getVm ,
  
}
/* No side effect */
